module.exports = __webpack_public_path__ + "static/img/7.5223960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/7.png
// module id = 4luK
// module chunks = 0